// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

// Types
interface Type {
  address: string | null
  country_name: string | null
  email: string
  handphone: string
  province_name: string | null
  regency_name: string | null
  subdistrict_name: string | null
  vendor_name: string
}

export function useVendorDetail(vendor_id?: string): {
  data: Type | null
  isLoading: boolean
} {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<Type | null>(null)
  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    api.get(
      "/vendor/byid",
      { params: { vendor_id } }
    ).then((res: SuccessFetch<{
      payload: Type[]
    }>) => {
      setData(res.data.payload[0])
    }).catch(() => {
      setData(null)
    }).finally(() => {
      setLoading(false)
    })

    return () => {
      setData(null)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}